import styled from "styled-components";

export const PieChartWrapper = styled.div`
    width: 100%;
    height: 100%;
`;
